export enum UserRole {
  KpmgAdmin = 'kpmgadmin',
  KpmgUser = 'kpmguser',
  PowerUser = 'poweruser',
  TenantAdmin = 'tenantadmin',
  User = 'user',
}
